import { TrackingEvent } from "../constants/events";
import { track } from "./tracker";

export const InitialState = {};

export const AnalyticsReducer = (state, action) => {
  switch (action.type) {
    // User Events
    // case TrackingEvent.VIRTUAL_USER_INFO:
    case TrackingEvent.VIRTUAL_PV:
    // Search Events
    case TrackingEvent.SEARCH_RESULT:
    case TrackingEvent.NO_SEARCH_RESULT:
    case TrackingEvent.SEARCH:
    // CTA Click Events
    case TrackingEvent.CTA_CLICK:
    case TrackingEvent.CTA_CLICKED:
    // Coupon Events
    case TrackingEvent.SELECT_COUPON:
    case TrackingEvent.VIEW_COUPON:
    case TrackingEvent.COUPON_APPLIED:
    // Reservation Events
    case TrackingEvent.CHECK_RESERVATION:
    case TrackingEvent.CALL_TO_CANCEL_RESERVATION:
    case TrackingEvent.SUPPORT_TO_CANCEL_RESERVATION:
    // Switch Events
    case TrackingEvent.SWITCH_TO_FLIGHT:
    case TrackingEvent.SWITCH_TO_FERRY:
    case TrackingEvent.PROMOTIONAL_BANNER_CLICKED:

    // Filter & Sort Events
    case TrackingEvent.FILTER_APPLIED:
    case TrackingEvent.SORTING_APPLIED:

    // E-commerce Events
    case TrackingEvent.VIEW_ITEM_LIST:
    case TrackingEvent.SELECT_ITEM:
    case TrackingEvent.VIEW_ITEM:
    case TrackingEvent.ADD_TO_CART:
    case TrackingEvent.ADD_TO_WISHLIST:
    case TrackingEvent.BEGIN_CHECKOUT:
    case TrackingEvent.EXTRA_SERVICE:
    case TrackingEvent.ADD_PAYMENT_INFO:
    case TrackingEvent.PURCHASE:
    case TrackingEvent.REFUND:
    // Invoice Events
    case TrackingEvent.SAVE_INVOICE:
    // Error Events
    case TrackingEvent.SIGN_UP_FAILED:
    case TrackingEvent.LOGIN_FAILED:
    case TrackingEvent.ERROR:
    case TrackingEvent.SHOWN_ERROR:
    // Authentication Events
    case TrackingEvent.SIGN_UP:
    case TrackingEvent.LOGIN:
    // Credit Card Points Events
    case TrackingEvent.QUERY_CREDIT_CARD_POINTS:
    case TrackingEvent.CONVERT_TO_TURNA_POINTS:
    case TrackingEvent.CONVERT_TO_TURNA_POINTS_COMPLETE:
    // Promotion Events
    case TrackingEvent.VIEW_PROMOTION:
    case TrackingEvent.SELECT_PROMOTION:
    case TrackingEvent.HOTEL_MAP_VIEW:
      track(action.type, { ...action.payload });
      return state;

    default:
      return state;
  }
};
